<template>
  <v-layout column justify-space-between>

    <ShiftReminder />

    <v-layout row wrap justify-space-between>
      <v-flex xs12 md6 grow class="pa-2">
        <ActivityCenter />
      </v-flex>

      <v-flex xs12 md6 grow class="pa-2">
        <TimeClock class="mb-4"/>
        <ShiftsSummary class="mb-4"/>
        <EventRSVPs v-if="invites.length > 0" />
      </v-flex>
    </v-layout>

    <v-layout row>
      <v-flex>
        <AvailableShifts />
      </v-flex>
    </v-layout>
   
  </v-layout>
</template>

<script>
import { mapState } from 'vuex'

import ActivityCenter from '@/components/dashboard/activity-center.vue'
import TimeClock from '@/components/dashboard/time-clock.vue'
import ShiftsSummary from '@/components/dashboard/shifts-summary.vue'
import EventRSVPs from '@/components/dashboard/event-rsvps.vue'
import AvailableShifts from '@/components/dashboard/available-shifts.vue'
import ShiftReminder from '@/components/dashboard/shift-reminder.vue'

import inviteApi from '@/api/invites';

export default {
  components: {
    ActivityCenter,
    TimeClock,
    ShiftsSummary,
    AvailableShifts,
    ShiftReminder,
    EventRSVPs,
  },
  computed: {
    ...mapState('userAuth', [
      'user',
    ]),
  },
  created () {
    this.fetchInvites()
  },
  watch: {
  },
  data: function () {
    return {
      invites: []
    }
  },
  methods: {
    fetchInvites() {
      inviteApi.getMine(invites => {
        this.invites = invites
      })
    },
  },
}
</script>
